<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_4"></a> </p>
<p class="copyright"> </p>
<p class="copyright">This is a work of fiction. All the characters and events portrayed in this novel are either fictitious or are used fictitiously.</p>
<p class="copyright"><span class="small">FOUR AND TWENTY BLACKBIRDS</span></p>
<p class="copyright">Copyright © 2003, 2005 by Cherie Priest</p>
<p class="copyright">Unrevised, shorter version published in 2003 by Marietta Publishing</p>
<p class="copyright">All rights reserved, including the right to reproduce this book, or portions thereof, in any form.</p>
<p class="copyright">Edited by Liz Gorinsky</p>
<p class="copyright"><em>Book design by Nicole de las Heras</em></p>
<p class="copyright">A Tor Book<br/>Published by Tom Doherty Associates, LLC<br/>175 Fifth Avenue<br/>New York, NY 10010</p>
<p class="copyright"><span class="weblink"><a class="nounder" href="http://www.tor.com" target="_blank">www.tor.com</a></span></p>
<p class="copyright">Tor<sup>®</sup> is a registered trademark of Tom Doherty Associates, LLC.</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright1">Priest, Cherie.</p>
<p class="copyright2">Four and twenty blackbirds / Cherie Priest.—1st Tor ed.</p>
<p class="copyright2">    p. cm.</p>
<p class="copyright2">“A Tom Doherty Associates Book.”</p>
<p class="copyright2">ISBN 0-765-31308-1 (pbk.)</p>
<p class="copyright2">EAN 978-0-765-31308-9</p>
<p class="copyright2">1. Orphans—Fiction. 2. Young women—Fiction. 3. Blessing and cursing—Fiction. 4. Racially mixed people—Fiction. 5. Signal Mountain (Tenn.)—Fiction. 6. Birthfathers—Fiction. 7. Georgia—Fiction. I. Title.</p>
<p class="copyright3">PS3616.R537F685 2005<br/>813’.6—dc22</p>
<p class="attribute">2005040584</p>
<p class="copyright">First Tor Edition: October 2005</p>
<p class="copyright">Printed in the United States of America</p>
<p class="copyright">10   9   8   7   6   5   4   3</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?0b252211